const strActiveOverlays = (activeOverlay) => {
  return Object.keys(activeOverlay).reduce((agg, layer) => {
    const _converIntoStr = activeOverlay[layer]["status"].toString();
    agg[layer] = {
      ...activeOverlay[layer],
      status: _converIntoStr,
    };
    return agg;
  }, {});
};

export { strActiveOverlays };
